import {z} from '@hono/zod-openapi';

export const priceReportArgumentsStatusSchema = z
  .enum(['pending', 'completed', 'failed'])
  .openapi('PriceReportArgumentsStatus');
